import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Button from 'components/Form/Button';
import App from 'modules/App';
const ActionButton = ({ entity, labelMessage, onAction })=>{
    const onClick = ()=>onAction(entity);
    return /*#__PURE__*/ _jsx(Button, {
        labelMessage: labelMessage || App.messages.buttons.edit,
        className: "btn--outline",
        onClick: onClick
    });
};
export default ActionButton;
